import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
import { memo } from 'react';

const SvgComponent = () => (
  <Svg width="23" height="14" viewBox="0 0 23 14" fill="none">
    <Path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7962 0.292893C13.3717 0.683418 13.3717 1.31658 13.7962 1.70711L18.4623 6H4.61926C4.04898 6 3.58667 6.44772 3.58667 7C3.58667 7.55228 4.04898 8 4.61926 8H18.4623L13.7962 12.2929C13.3717 12.6834 13.3717 13.3166 13.7962 13.7071C14.2207 14.0976 14.9089 14.0976 15.3333 13.7071L21.7333 7.81909C21.9994 7.63821 22.1733 7.33878 22.1733 7C22.1733 6.66122 21.9994 6.36179 21.7333 6.18091L15.3333 0.292893C14.9089 -0.0976311 14.2207 -0.0976311 13.7962 0.292893ZM0.306673 7C0.306673 7.55228 0.796175 8 1.40001 8C2.00384 8 2.49334 7.55228 2.49334 7C2.49334 6.44772 2.00384 6 1.40001 6C0.796175 6 0.306673 6.44772 0.306673 7Z"
      fill="white"
    />
  </Svg>
);

const ArrowRightSwipe = memo(SvgComponent);
export default ArrowRightSwipe;
